import { render } from "./AdminChamCongQuick.vue?vue&type=template&id=73a838b9&scoped=true"
import script from "./AdminChamCongQuick.vue?vue&type=script&lang=js"
export * from "./AdminChamCongQuick.vue?vue&type=script&lang=js"

import "./AdminChamCongQuick.vue?vue&type=style&index=0&id=73a838b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73a838b9"]])

export default __exports__